import { AccountPage } from './account/AccountPage';
import { CheckoutPage } from './account/CheckoutPage';
import { AccountGate, SignInPage } from './account/Access';
import { MyVideos } from './components/MyVideos';
import { PublicHome, PricingPage } from './public/PublicPages';
import { PolicyPage } from './public/PolicyPage';
import { Studio } from './Studio';
import { SamplesPage } from './public/samples/SamplesPage';

export default function App() {
  const path = location.pathname;
  useEffect(() => {
    const titles: Record<string, string> = { '/': 'Recorded routes in motion', '/pricing': 'Plans and pricing', '/samples': 'Video samples, maps, and cameras', '/privacy': 'Privacy Policy', '/terms': 'Terms of Use', '/sign-in': 'Sign in', '/sign-up': 'Create account', '/studio': 'Studio', '/account': 'Account and billing', '/checkout': 'Checkout', '/videos': 'My videos' };
    document.title = `OVERLAND TRACES — ${titles[path] ?? 'Recorded routes in motion'}`;
  }, [path]);
  if (path === '/' && new URLSearchParams(location.search).get('render') === 'video') return <Studio />;
  if (path === '/') return <PublicHome />;
  if (path === '/pricing') return <PricingPage />;
  if (path === '/samples') return <SamplesPage />;
  if (path === '/privacy' || path === '/terms') return <PolicyPage kind={path === '/privacy' ? 'privacy' : 'terms'} />;
  if (path === '/sign-in' || path === '/sign-up') return <SignInPage />;
  if (path === '/studio') return <AccountGate create><Studio /></AccountGate>;
  if (path === '/account') return <AccountGate><AccountPage /></AccountGate>;
  if (path === '/checkout') return <AccountGate><CheckoutPage /></AccountGate>;
  if (path === '/videos') return <AccountGate><MyVideos /></AccountGate>;
  return <PublicHome />;
}
import { useEffect } from 'react';
